<template>
    <div class="c-tags-list">
        <div class="c-tag" v-for="(tag, index) in tags">
            {{ tag }}
            <button class="tag-close" @click="removeTag(tag)">x</button>
        </div>

        <button class="tags-list-clear" v-if="tags.length" @click="clearAll">
            Clear tags
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            tags: { type: Array }
        },
        methods: {
            removeTag: function (tag) {
                this.$emit("remove", tag);
            },
            clearAll: function () {
                this.$emit("clearAll");
            }
        }
    }
</script>